
import Vue, { PropType } from "vue";
import { LongStayAlertSetting } from "@/models";
import BaseInputForm from "@/components/BaseInputForm.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";

type DataType = {
  maxStayDurationSeconds: string;
};

export default Vue.extend({
  name: "LongStayAlertSettingEditor",

  components: {
    BaseInputForm,
    BaseSubmitButton,
  },

  props: {
    alertSetting: Object as PropType<LongStayAlertSetting>,
    loading: Boolean as PropType<boolean>,
    checked: Boolean as PropType<boolean>,
  },

  data() {
    return {
      maxStayDurationSeconds: "",
    };
  },

  computed: {
    canSubmit(): boolean {
      return Number.isInteger(Number(this.maxStayDurationSeconds)) && Number(this.maxStayDurationSeconds) > 0;
    },
  },

  watch: {
    alertSetting: function(n: LongStayAlertSetting) {
      this.maxStayDurationSeconds = n.maxStayDurationSeconds ? String(n.maxStayDurationSeconds) : "";
    },
  },

  methods: {
    save() {
      if (!this.canSubmit) {
        return;
      }

      this.$emit(
        "save-long-stay-alert-setting",
        new LongStayAlertSetting({
          companyId: this.$auth.companyId,
          maxStayDurationSeconds: parseInt(this.maxStayDurationSeconds) || 0,
        }),
      );
    },
  },
});
